module.exports = __webpack_public_path__ + "img/networkCard_250x250.70b806c2.svg";